"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XHRStUyAuthUrl = void 0;
class XHRStUyAuthUrl {
    constructor() {
        this.name = this.constructor.name;
    }
    async handleRequest(request) {
        if (request.url.includes('mb-api-auth')) {
            request.url = request.url.replace('mb-api-auth', 'st-api-auth');
        }
        return Promise.resolve(request);
    }
}
exports.XHRStUyAuthUrl = XHRStUyAuthUrl;
//# sourceMappingURL=xhrStUyAuthUrl.js.map